export default __webpack_public_path__ + "static/media/vox-img-legacy-007.389a5bb9.jpg";